/* eslint-disable @typescript-eslint/no-unused-vars */ import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from 'react';
import styled, { css, ThemeContext } from 'styled-components';
import { getActiveMode } from '@nib-components/theme';
import { m, p } from '../spacing';
import { isList } from '../utils';
import { margins } from './lib/margin';
import { paddings } from './lib/padding';
import { display } from './lib/display';
import { width, maxWidth, height, maxHeight, minWidth, minHeight } from './lib/dimensions';
import { gridColumn, gridRow } from './lib/grid';
import { alignItems, justifyContent, flexDirection, flexWrap, flexGrow, flexShrink, alignSelf } from './lib/flex';
import { textAlign } from './lib/textAlign';
import { background, foreground, color } from './lib/colors';
import { borderRadius } from './lib/border-radius';
import { boxShadow } from './lib/box-shadow';
import { columnGap, gap, rowGap } from './lib/gap';
import { lineHeight } from './lib/line-height';
import { position } from './lib/position';
import { overflow } from './lib/overflow';
import { border } from './lib/border';
import { zIndex } from './lib/z-index';
export const Box = styled(({ padding, paddingVertical, paddingHorizontal, paddingTop, paddingBottom, paddingLeft, paddingRight, paddingBlockStart, paddingInlineEnd, paddingBlockEnd, paddingInlineStart, paddingBlock, paddingInline, margin, marginVertical, marginHorizontal, marginTop, marginBottom, marginLeft, marginRight, marginBlockStart, marginInlineEnd, marginBlockEnd, marginInlineStart, marginBlock, marginInline, display, width, minWidth, maxWidth, height, minHeight, maxHeight, alignItems, alignSelf, justifyContent, flexDirection, flexWrap, flexGrow, flexShrink, gridColumn, gridRow, textAlign, background, foreground, color, borderRadius, boxShadow, gap, columnGap, rowGap, lineHeight, position, overflow, zIndex, isolate, borderStyle, borderColor, borderWidth, mode, as, ...rest })=>{
    const theme = useContext(ThemeContext);
    return /*#__PURE__*/ _jsx("div", {
        "data-mesh-component": "BOX",
        "data-mode": mode && getActiveMode(theme.id, mode),
        ...rest
    });
})`
  box-sizing: border-box;

  /* If box is set to be a ul or ol we need to reset the default styling */
  ${({ as })=>as && isList(as) && css`
      ${m(0)};
      ${p(0)};
      list-style-type: none;
    `}

  ${({ isolate })=>isolate && css`
      isolation: isolate;
    `}

  ${(props)=>margins()};
  ${(props)=>paddings()};

  ${(props)=>display()};

  ${(props)=>width()};
  ${(props)=>minWidth()};
  ${(props)=>maxWidth()};
  ${(props)=>height()};
  ${(props)=>minHeight()};
  ${(props)=>maxHeight()};

  ${(props)=>alignItems()};
  ${(props)=>alignSelf()};
  ${(props)=>justifyContent()};
  ${(props)=>flexDirection()};
  ${(props)=>flexWrap()};
  ${(props)=>flexGrow()};
  ${(props)=>flexShrink()};

  ${(props)=>gridColumn()};
  ${(props)=>gridRow()};

  ${(props)=>textAlign()};

  ${(props)=>background()};
  ${(props)=>color()}; /* deprecated, use foreground instead */
  ${(props)=>foreground()};
  ${(props)=>borderRadius()};
  ${(props)=>boxShadow()};

  ${(props)=>gap()};
  ${(props)=>columnGap()};
  ${(props)=>rowGap()};
  ${(props)=>lineHeight()};
  ${(props)=>position()};
  ${(props)=>overflow()};
  ${(props)=>border()};
  ${(props)=>zIndex()};
`;
Box.displayName = 'Box';

//# sourceMappingURL=index.js.map